import React, {useEffect, useState} from "react";
import {mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {DocumentsBatch, RefpadoDocument} from "../../types";
import {QRFooter} from "../qr_footer/QRFooter";
import {RefregdResponse} from "../../types/refpregd";
import {selectedDocument} from "./index";
import {AvailableDocuments} from "./AvailableDocuments";

export const RefregdDoc: React.FC<{ documents: DocumentsBatch , withVersions?: boolean }> = ({
                                                                                                 documents,
                                                                                                 withVersions = true
                                                                                             }) => {
    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<RefregdResponse>(
            selectedDocument.document.document as RefregdResponse
    )

    const isDeadAlone = doc.personInfo.regType === '0';
    // const isConstReg = doc.personInfo.regType === '1';
    // const isTempReg = doc.personInfo.regType === '2';


    useEffect(() => {
        setDocument(selectedDocument.document.document as RefregdResponse);
    }, [selectedDocument.document.version]);


    const title = `${isDeadAlone
            ? 'Справка об одиноком умершем'
            : 'Справка о регистрации с умершим на дату смерти по адресу'} № ${mayBe(doc.refNumber) || 'б/н'}`;
    const subTitle = `Выдана заявителю:`;

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };


    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>
                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.personInfo.lastName)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.personInfo.firstName)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.personInfo.midName)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.personInfo.birthdate) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={getDocument(doc.personInfo.document)}
                        />
                    </div>

                    <DocTitle subtitle={'Свидетельствует о том, что гражданин:'} title={''}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Фамилия" bold value={mayBe(doc.deadInfo.lastName)}/>
                        <DocRow title="Имя" bold value={mayBe(doc.deadInfo.firstName)}/>
                        <DocRow title="Отчество" bold value={mayBe(doc.deadInfo.midName)}/>
                        <DocRow title="Дата рождения" bold value={mayBe(doc.deadInfo.birthdate) || '-'}/>
                        <DocRow
                                title="Документ удостоверяющий личность"
                                bold
                                value={getDocument(doc.deadInfo.document)}
                        />
                    </div>

                </div>
                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }

                <div className="col-span-12 md:col-span-8 md:order-last">
                    <div className="pl-3 pb-5 mt-5 bottom-line">
                        <DocRow title="Свидетельство о смерти" bold
                                value={`№ ${doc.deadInfo.drecNum} от ${doc.deadInfo.drecDate}`}/>
                        <DocRow title="Выдано" bold value={mayBe(doc.deadInfo.drecZags) || '-'}/>
                        <DocRow title="Актовая запись" bold
                                value={`№ ${doc.deadInfo.actzapNum} от ${doc.deadInfo.actzapDate}`}
                        />
                        <DocRow title="Оформлена" bold value={mayBe(doc.deadInfo.actzapZags) || '-'}/>
                    </div>

                    <div className="pl-3 pb-5 mt-5 bottom-line">
                        <DocRow title="Был зарегистрирован по месту жительства в период"
                                bold
                                value={`c ${mayBe(doc.deadInfo.regDate)} по дату смерти ${mayBe(doc.deadInfo.deathDate)}`}/>
                        <DocRow title="По адресу" bold value={mayBe(doc.deadInfo.regAddress)}/>
                    </div>

                    {isDeadAlone && <DocTitle title={''}
                                              subtitle={'На дату смерти был зарегистрирован один.'}/>
                    }
                    {doc?.matesConst?.length > 0 &&
                            <>
                                <DocTitle title={''}
                                          subtitle={'С гражданином на дату смерти по адресу были зарегистрированы по месту жительства:'}/>
                                {doc.matesConst.map((mate, idx) =>
                                        <div className="pl-3 pb-5 mt-5 bottom-line" key={idx}>
                                            <DocRow title="Фамилия" bold value={mayBe(mate.lastName)}/>
                                            <DocRow title="Имя" bold value={mayBe(mate.firstName)}/>
                                            <DocRow title="Отчество" bold value={mayBe(mate.midName)}/>
                                            <DocRow title="Дата рождения" bold
                                                    value={mayBe(mate.birthDate) || '***'}/>
                                            <DocRow title="Дата регистрации" bold
                                                    value={mayBe(mate.regDate) || '***'}/>
                                        </div>
                                )}
                            </>
                    }
                    {doc?.matesTemp?.length > 0 &&
                            <>
                                <DocTitle title={''}
                                          subtitle={'С гражданином на дату смерти по адресу были зарегистрированы по месту пребывания:'}/>
                                {
                                    doc.matesTemp.map((mate, idx) =>
                                            <div className="pl-3 pb-5 bottom-line" key={idx}>
                                                <DocRow title="Фамилия" bold value={mayBe(mate.lastName)}/>
                                                <DocRow title="Имя" bold value={mayBe(mate.firstName)}/>
                                                <DocRow title="Отчество" bold value={mayBe(mate.midName)}/>
                                                <DocRow title="Дата рождения" bold
                                                        value={mayBe(mate.birthDate) || '***'}/>
                                                <DocRow title="Дата регистрации" bold
                                                        value={mayBe(mate.regDate) || '***'}/>
                                            </div>
                                    )
                                }
                            </>

                    }
                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.refDate}
                              mfcInfoName={doc.mfcInfo.name}
                              mfcUserName={doc.mfcUser.name}
                    />
                </div>
            </>
    );
};
